module.exports = __webpack_public_path__ + "img/full5-min.718cb132.png";